import { useNavigate } from 'react-router-dom';

import Layout from 'hb-react/frontoffice/apps/Mentoring/components/Layout';
import { CreateMentor } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Mentor/CreateMentor';
import { ReapplyMentor } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Mentor/ReapplyMentor';
import type {
  CustomAttributeType,
  MentorProfile,
  Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { getLowerCaseMentorLabel } from 'hb-react/frontoffice/apps/Mentoring/utils';

interface ApplyMentorFormsProps {
  program: Program;
  mentorProfile?: MentorProfile | { status: null };
  attributes: CustomAttributeType[];
}

export const ApplyMentorForms = ({
  program,
  mentorProfile,
  attributes,
}: ApplyMentorFormsProps) => {
  const {
    applied_to_be_mentor_text: applicationDescription,
    mentor_label: mentorLabel,
    name,
    mode,
  } = program;
  const navigate = useNavigate();

  const title = s__('Mentoring|Apply to become a %{label} in %{name}').i__({
    label: getLowerCaseMentorLabel(mentorLabel),
    name,
  });

  const onSuccess = () => {
    navigate(mode === 'admin_match' ? '/my-mentoring' : '../../mentors');
  };

  if (mentorProfile?.status === 'rejected_can_reapply') {
    return (
      <Layout dataTestId="can-reapply-form">
        <ReapplyMentor
          program={program}
          attributes={attributes}
          applicationDescription={applicationDescription}
          mentorProfile={
            mentorProfile as MentorProfile & {
              status: 'rejected_can_reapply';
            }
          }
          title={title}
          onSuccess={onSuccess}
        />
      </Layout>
    );
  }

  return (
    <Layout dataTestId="create-form">
      <CreateMentor
        program={program}
        attributes={attributes}
        applicationDescription={applicationDescription}
        title={title}
        onSuccess={onSuccess}
      />
    </Layout>
  );
};
